import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ShipIcon from '@/assets/icons/ship.svg?inline';
import { CategoryItem } from '@/common/interfaces/modules/DatesAndRates';
import CabinCategoryItem from '../CabinCategoryItem/CabinCategoryItem.vue';

@Component({
  components: {
    ShipIcon,
    CabinCategoryItem,
  },
})
export default class CabinCategoryContainer extends Vue {
  @Prop({ type: Array as () => CategoryItem[], default: [] })
  readonly Categories!: CategoryItem[];

  @Prop({ type: String, default: '' })
  layoutType!: string;

  @Prop({ type: String, default: '' })
  shipName!: string;

  showCabinOnSvg(code: any) {
    this.$emit('showCabinOnSvg', code);
  }

  get uniqueCategories() {
    const cats = this.$props.Categories;
    const uniqueCats = Array.from(
      new Set(cats
        .filter(c => c.Code !== "PS")
        .map(el => el.Id)))
        .map(id => cats.find(el => el.Id === id));
    return uniqueCats;
  }
}
